<template>
  <div style="font-size: 18px">更新日志</div>
  <div style="margin: 50px" v-for="item in log" v-bind:key="item">
    <div style="font-size: 20px; text-align: left; color: #aaaaaa; margin: 10px 0">
      {{ item.time }}
    </div>
    <ul>
      <li
        style="text-align: left; font-size: 16px; color: #666666; margin: 5px 0"
        v-bind:key="content"
        v-for="content in item.content"
      >
        {{ content }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      log: [
        {
          time: "2023-5-10",
          content: ["增加产品‘适用范围’属性", "更新产品状态为 ‘样品/已确认/量产’"],
        },
        {
          time: "2022-12-06",
          content: [
            "修改客户项目进度表为固定表头",
            "增加'业务负责人字段'",
            "增加更新记录显示功能",
            "客户项目进度表时间轴仅显示当前月",
            "增加更新日志显示功能",
          ],
        },
        {
          time: "2022-11-25",
          content: [
            "增加‘故障处理措施’显示功能，提供错误码及处理措施查询",
            "资料下载页面增加'是否需要审批'切换按钮",
            "将客户项目进度表中的固定阶段修改为可自定义阶段",
            "增加操作记录分类显示与查询",
          ],
        },
        {
          time: "2022-8-20",
          content: [
            "增加英文语言切换选项，UI控件翻译完成，部分录入内容翻译完成",
            "增加产品目录下'模糊查询'功能并高亮显示查询结果",
            "增加移动端适配",
            "根据产品类别增加筛选条件",
          ],
        },
        {
          time: "2022-06-10",
          content: [
            "产品列表顶部增加分页按钮栏",
            "翻页后页面跳转至顶部",
            "产品信息页增加返回上一级按钮",
            "修复上传图标按钮点击一次失效问题",
            "资料下载删除审批无效修复",
            "撤回审批无操作记录修复",
            "上传资料时自动填写文件名",
          ],
        },
        {
          time: "2022-05-24",
          content: [
            "产品类别增加上传图标显示功能",
            "产品类别增加拖动排序功能",
            "产品备注修改为选填项",
            "产品备注支持多行输入",
            "产品列表可显示多个车款编号及",
            "流程审批增加拒绝理由字段",
            "我提交的审批增加撤回按钮",
            "新增资料下载功能",
            "新增资料pdf预览功能",
            "新增资料上传功能",
            "新增客户项目进度表显示功能",
            "客户项目进度表自动显示逾期状况",
            "客户项目进度表阶段支持附件上传功能",
          ],
        },
        {
          time: "2022-03-16",
          content: [
            "增加登录界面右上角显示登录人姓名",
            "修复'操作记录'界面中修改前后数据对比显示有误问题",
            "修复'流程审批'界面中操作人员显示有误问题",
            "操作记录、审批详情页面图片显示修改为显示原图",
            "产品录入中去除型号中所有空格字符",
            "产品查询中去除型号查询参数中所有空格字符",
          ],
        },
        {
          time: "2022-03-14",
          content: [
            "登录页增加版本号显示",
            "修复主页界面回到顶部箭头弹出代码问题",
            "登录界面增加回车键登录功能",
            "增加token过期时间防止编辑后提交返回登录页问题",
            "修改产品类别弹出框增加取消按钮",
            "流程提交后邮件通知具有审核权限的用户",
            "发件人邮箱修改为阿里企业邮件推送",
            "修复审批详情页面操作与审批成员显示数字问题",
            "审批列表增加刷新按钮",
            "上传图片增加提示信息",
            "移除产品列表富文本编辑器中元素路径显示框",
            "修复产品列表下内容过长导致表格挤压问题",
            "修改新增产品排列在最后一位",
            "修复同一时间操作审批流程双重执行问题",
          ],
        },
        {
          time: "2022-03-02",
          content: [
            "首次上线发布，包含如下功能🔆",
            "产品管理",
            "产品查询",
            "类别管理",
            "用户管理",
            "流程审批",
          ],
        },
      ],
    };
  },
};
</script>

<style></style>
